import { unauthorizedBackendApi } from '@app/services'

import { ConfigurationResponse } from './types'

export const fetchConfiguration = async () => {
  const { data } =
    await unauthorizedBackendApi.get<ConfigurationResponse>('/configuration')

  return data
}
